/* 🤖 this file was generated by svg-to-ts */
export const iconAave: {
  name: 'aave';
  data: string;
} = {
  name: 'aave',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#9391F7" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" d="M13.03 16.78c1.37-.22 2.3-1.52 2.08-2.89a2.52 2.52 0 0 0-2.89-2.08c-1.37.22-2.3 1.52-2.08 2.89s1.52 2.3 2.89 2.08m6.58 0c1.37-.22 2.3-1.52 2.08-2.89a2.52 2.52 0 0 0-2.89-2.08c-1.37.22-2.3 1.52-2.08 2.89s1.52 2.3 2.89 2.08"/><path fill="#fff" d="M15.91 3.91c-6.83 0-12.37 5.65-12.37 12.61H6.7c0-5.22 4.09-9.45 9.21-9.45s9.21 4.23 9.21 9.45h3.16c0-6.96-5.54-12.61-12.37-12.61"/></svg>`,
};
